/**
 * Vista previa de código para rubros/subrubros (altas nuevas).
 * Debe coincidir con backend/app/productos/codigo_utils.py (normalize + MAX_CODIGO_LEN).
 */
const MAX_CODIGO_LEN = 20;

const STOP_PARTS = new Set(["Y", "E", "O", "A", "DE", "DEL", "LA", "LAS", "LOS"]);

function stripAccents(s: string): string {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function normalizeNombreToCodigoBase(nombre: string, emptyFallback: string): string {
  const t = (nombre ?? "").trim();
  if (!t) return emptyFallback;
  let s = stripAccents(t).toUpperCase();
  s = s.replace(/[^A-Z0-9]+/g, "-");
  s = s.replace(/-+/g, "-").replace(/^-|-$/g, "");
  return s || emptyFallback;
}

/** Misma lógica que abbreviate_slug_for_codigo en productos/codigo_utils.py */
export function abbreviateSlugForCodigo(slug: string, emptyFallback: string): string {
  const parts = slug.split("-").filter(Boolean);
  if (parts.length === 0) return emptyFallback;

  if (parts.length >= 2) {
    const initials: string[] = [];
    for (const p of parts) {
      if (STOP_PARTS.has(p) && parts.length > 2) continue;
      initials.push(p[0] ?? "");
    }
    const ac = initials.join("");
    if (ac.length >= 2) return ac.slice(0, MAX_CODIGO_LEN);
    if (ac.length >= 1) return ac.slice(0, MAX_CODIGO_LEN);
  }

  const w = parts[0] ?? "";
  if (w.length > 5) return w.slice(0, 3);
  return w.slice(0, MAX_CODIGO_LEN);
}

/** Primera opción de código (sin comprobar colisiones en BD). */
export function previewCodigoFromNombre(
  nombre: string,
  kind: "grupo" | "subgrupo"
): string {
  const fb = kind === "grupo" ? "RUBRO" : "SUB";
  const slug = normalizeNombreToCodigoBase(nombre, fb);
  return abbreviateSlugForCodigo(slug, fb).slice(0, MAX_CODIGO_LEN);
}
